import { forwardRef, useId, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "../../lib/utils";

const PasswordInput = forwardRef(function PasswordInput(
  { label, error, className, id, ...props },
  ref
) {
  const [visible, setVisible] = useState(false);
  const generatedId = useId();
  const inputId = id ?? generatedId;

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label htmlFor={inputId} className="text-lg font-medium text-text-dark/80">
          {label}
        </label>
      )}

      <div className="relative">
        <input
          id={inputId}
          ref={ref}
          type={visible ? "text" : "password"}
          className={cn(
            "h-13 w-full rounded-xl border bg-text-dark/8 px-4 pl-11 text-base text-text-dark placeholder:text-text-dark/40 outline-none transition-all duration-200 focus:ring-2",
            error
              ? "border-red-500/60 focus:border-red-500 focus:ring-red-500/30"
              : "border-white/15 focus:border-emerald-500 focus:ring-emerald-500/30",
            className
          )}
          {...props}
        />

        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/70"
          tabIndex={-1}
        >
          {visible ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
        </button>
      </div>

      {error && <p className="text-xs text-red-400">{error}</p>}
    </div>
  );
});

export default PasswordInput;

